<template>

  <div>
    <swiper
      style="height: 35vw;"
      :modules="modules"
      :slides-per-view="1"
      :navigation="{nextEl: '#button-next',prevEl: '#button-prev'}"
      :pagination="{ clickable: true, type: 'bullets' }"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: false
      }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide  v-for="image in images">
        <div class="top-bg-img hero-banner" :style="`
          background-image: url(${image});
          background-repeat: no-repeat;
          background-size: cover;
          `"
        >
          <div class="container d-flex align-items-center">
            <div class="flex-row">
              <div class="col p-2 p-sm-4 rounded-3 light-black text-white text-center">
                <div class="h2 heading text-uppercase pb-3 lh-sm">
                  Stort utvalg - Auksjon hver dag!
                </div>
                <a
                  role="button"
                  class="btn btn-primary light-button text-uppercase custom-shadow"
                  href="/login"
                >Logg inn og se bilene!</a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div id="button-next" class="swiper-button-next">
        <img src="/themes/default/images/icons/right-arrow.png" alt="right arrow">
      </div>
      <div id="button-prev" class="swiper-button-prev">
        <img src="/themes/default/images/icons/left-arrow.png" alt="left arrow">
      </div>
    </swiper>
  </div>


</template>

<script>
import {Navigation, Pagination, A11y, Thumbs, Autoplay} from 'swiper';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/css/bundle';

export default {
  components: {
    Swiper,
    SwiperSlide,
    Autoplay
  },
  directives: {
    //swiper: directive
  },
  props: ['prop_images'],
  setup() {
    const onSwiper = (swiper) => {
    };
    const onSlideChange = () => {
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y, Thumbs, Autoplay],
    };
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '#button-next',
          prevEl: '#button-prev'
        },
        // Some Swiper option/callback...
      },

      images: []
    }
  },

  mounted() {
    this.images = JSON.parse(this.prop_images)
  }
}
</script>
<style scoped>
.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}
</style>



